import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL, IFraudReviewRequestDto } from '@/dtos';

import { FRAUD_REVIEW_STATUS_QUERY_KEY } from '../fraudReview.constants';

const putFraudReview = (employeeId: string, isFraudReviewRequired: boolean) =>
  api.put<IFraudReviewRequestDto>(API_URL.EMPLOYEES_FRAUD_REVIEW_BY_EMPLOYEE_ID(employeeId), {
    is_fraud_review_required: isFraudReviewRequired,
  });

const useUpdateFraudReviewQuery = (employeeId?: string, onSuccess?: () => void) => {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation(
    (isFraudReviewRequired: boolean) => putFraudReview(employeeId || '', isFraudReviewRequired),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [FRAUD_REVIEW_STATUS_QUERY_KEY, employeeId] });
        if (onSuccess) onSuccess();
      },
    }
  );

  return {
    updateFraudReview: mutateAsync,
    isPending,
  };
};

export default useUpdateFraudReviewQuery;
